module.exports = __webpack_public_path__ + "img/image-quality.e80bc1a2.jpg";